export function occurrenceSortTime(occurrence) {
  const raw = occurrence && occurrence.date;
  const asDate = raw && raw.toDate ? raw.toDate() : new Date(raw);
  const value = asDate && asDate.getTime ? asDate.getTime() : NaN;
  return Number.isFinite(value) ? value : 0;
}

export function formatOccurrenceDate(occurrence, dateLocale, t) {
  const raw = occurrence && occurrence.date;
  const asDate = raw && raw.toDate ? raw.toDate() : new Date(raw);
  if (Number.isNaN(asDate.getTime())) {
    return "";
  }
  const parts = asDate.toLocaleString(dateLocale).split(",");
  return t("occurrences.dateAt", {
    date: parts[0],
    time: (parts[1] || "").trim()
  });
}

export function occurrenceStageLabel(occurrence) {
  const shortName = String(
    (occurrence && occurrence.stageShortName) || ""
  ).trim();
  if (shortName && shortName !== "-" && shortName !== "—") {
    return shortName;
  }
  const stage = String((occurrence && occurrence.stage) || "").trim();
  if (!stage || stage === "-" || stage === "—") {
    return "";
  }
  return stage;
}

export function formatOccurrenceWhen(occurrence, dateLocale, t) {
  const when = formatOccurrenceDate(occurrence, dateLocale, t);
  const stage = occurrenceStageLabel(occurrence);
  if (!when) {
    return stage;
  }
  if (!stage) {
    return when;
  }
  return t("occurrences.dateAtStage", {
    date: when,
    stage
  });
}

export function displayOccurrenceContext(value) {
  const text = String(value == null ? "" : value).trim();
  if (!text || text === "-" || text === "—") {
    return "—";
  }
  return text;
}
